import React from 'react'

const OurCoffees = props => {
    return (
        <div className="Our Coffees"></div>
    )
}

export default OurCoffees;